import React, { useEffect, useRef, useState } from "react";
import { Form, Spin, Select, Modal, DatePicker, Input, TimePicker } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";

const url = process.env.REACT_APP_API_BASE_URL;
const DocumentAdd = ({
  isModalOpen,
  handleCancel,
  handleFetch,
  prodd,
  prodd1,
}) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { activeObjPlannedProject } = useSelector((state) => ({
    activeObjPlannedProject: state.obj.activeObj["plannedProject"],
  }));

  const onFinish = async (data) => {
    const res = await dispatch(
      save({
        ...data,
        url: "api/v2/projectFiles/save",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await handleFetch();
      await form.resetFields();
      await handleCancel();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  return (
    <Modal
      title={`${
        prodd?.usrId
          ? "Update Training Session"
          : `Request a new Training Session`
      }`}
      open={isModalOpen}
      onOk={onFinish}
      onCancel={handleCancel}
      className="!w-[49.5rem]"
      maskClosable={false}
    >
      <Form
        layout="vertical"
        ref={formRef}
        name="control-ref"
        onFinish={onFinish}
        className=""
        style={{
          maxWidth: "100%",
        }}
        form={form}
      >
        <Form.Item
          label="Start Date"
          name="Date"
          rules={[
            {
              required: true,
              message: "Date is required",
            },
          ]}
        >
          <DatePicker format={"YYYY MMM DD"} className="input" />
        </Form.Item>
        <Form.Item
          name="examStartTime"
          label="Time"
          rules={[
            {
              required: true,
              message: "Time is required",
            },
          ]}
        >
          <TimePicker
            format={"HH:mm"}
            minuteStep={15}
            hourStep={1}
            className="input"
          />
        </Form.Item>

        <Form.Item
          name="damAgencyId"
          className=""
          label={"Type of Training"}
          rules={[
            {
              required: true,
              message: "Please select type of training",
            },
          ]}
        >
          <Select
            className=""
            allowClear
            style={{
              width: "100%",
            }}
            // options={
            //   dataAgency?.length > 0 &&
            //   dataAgency?.map((item) => ({
            //     value: item?.agencyId,
            //     label: item?.agencyName,
            //   }))
            // }
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </Form.Item>
        <Form.Item
          name="pfFileName"
          className=""
          label={"Location (Type on to choose a location near you)"}
          rules={[
            {
              required: true,
              message:
                "Please select location (Type on to choose a location near you)",
            },
          ]}
        >
          <Input className="input" />
        </Form.Item>

        <div className="flex justify-between mt-[48px] ">
          <div className="justify-start"></div>
          <div className="justify-end flex items-center mb-[58px] gap-x-5">
            <div className="w-[150px]">
              <button
                type="button"
                key="back"
                onClick={handleCancel}
                className="cstm-btn"
              >
                Cancel
              </button>
            </div>

            <div className="w-[150px]">
              <button
                disabled={saving}
                key="submit"
                type="submit"
                className="cstm-btn-2"
              >
                {saving ? <Spin /> : prodd?.usrId ? "Update" : "Submit"}
              </button>
            </div>
          </div>
        </div>
      </Form>
    </Modal>
  );
};
export default DocumentAdd;
